import {
  fetchStrapiCollection,
  fetchStrapiSingle,
  getStrapiMediaUrl,
  hasStrapiConfig,
} from "./client";
import { slugifyTribunalName } from "./phaseThreeContent";
import {
  contactsall as fallbackContacts,
  tribunals as fallbackTribunals,
  values as fallbackValues,
} from "../../components/resources/data/data";

const fallbackMainHeader = {
  heading: "TRIBUNALS IN KENYA",
  quote:
    "Judicial authority vests in and is to be exercised by courts and tribunals established by or under the Constitution.",
  citation: "Article 159 (1) of the Constitution of Kenya.",
  logoImage: "",
};

function sortByOrder(items) {
  return [...items].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
}

function mapContact(item) {
  return {
    id: item.id,
    name: item.name || "",
    telephone: item.phone || item.telephone || "",
    address: item.address || "",
    location: item.location || "",
    email: item.email || "",
    mapUrl: item.mapUrl || "",
  };
}

function mapTribunal(item) {
  const slug = item.slug || slugifyTribunalName(item.name || item.title || "");

  return {
    id: item.id,
    name: item.name || "",
    description: item.summary || item.description || "",
    slug,
    url: `/tribunals/${slug}`,
    legacyPath: item.path || item.url || "",
    sortOrder: item.sortOrder || 0,
  };
}

function mapValue(item) {
  return {
    id: item.id,
    title: item.title || "",
    desc: item.description || item.desc || "",
    sortOrder: item.sortOrder || 0,
  };
}

function mapMainHeader(item) {
  if (!item) {
    return fallbackMainHeader;
  }

  return {
    heading: item.heading || fallbackMainHeader.heading,
    quote: item.quote || fallbackMainHeader.quote,
    citation: item.citation || fallbackMainHeader.citation,
    logoImage: getStrapiMediaUrl(item.logoImage),
  };
}

async function withFallback(fetcher, fallbackData) {
  if (!hasStrapiConfig()) {
    return fallbackData;
  }

  try {
    const data = await fetcher();
    if (Array.isArray(data)) {
      return data.length > 0 ? data : fallbackData;
    }

    return data || fallbackData;
  } catch (error) {
    console.error("Falling back to local Phase 2 content because Strapi is unavailable.", error);
    return fallbackData;
  }
}

export function getContacts() {
  return withFallback(
    async () =>
      sortByOrder((await fetchStrapiCollection("/api/contact-locations")).map(mapContact)),
    fallbackContacts
  );
}

export function getTribunalListings() {
  return withFallback(
    async () =>
      sortByOrder((await fetchStrapiCollection("/api/tribunals")).map(mapTribunal)),
    sortByOrder(fallbackTribunals.map(mapTribunal))
  );
}

export function getSiteValues() {
  return withFallback(
    async () => sortByOrder((await fetchStrapiCollection("/api/site-values")).map(mapValue)),
    fallbackValues
  );
}

export function getMainHeaderContent() {
  return withFallback(
    async () => mapMainHeader(await fetchStrapiSingle("/api/global?populate[favicon]=true")),
    fallbackMainHeader
  );
}
